(() => {
  const widgetSelector = '.jdgm-rev-widg';
  let pageObserver;

  const updateVisibleReviewTones = (widget) => {
    const reviews = Array.from(widget.querySelectorAll('.jdgm-rev'));
    reviews.forEach((review) => review.removeAttribute('data-growber-review-tone'));
    reviews
      .filter((review) => window.getComputedStyle(review).display !== 'none')
      .forEach((review, index) => {
        review.setAttribute('data-growber-review-tone', index % 2 === 0 ? 'grey' : 'white');
      });
  };

  const scheduleToneUpdate = (widget) => {
    window.setTimeout(() => updateVisibleReviewTones(widget), 60);
    window.setTimeout(() => updateVisibleReviewTones(widget), 500);
  };

  const mobileReviewQuery = window.matchMedia('(max-width: 749px)');

  const normalizeReviewLocation = (value) => (value || '')
    .trim()
    .replace(/^\((.*)\)$/, '$1')
    .trim()
    .replace(/^Germany$/i, 'DE');

  const shortenDesktopProductTitle = (value) => {
    const title = (value || '').trim().replace(/\s+/g, ' ');
    const layerMatch = title.match(/^(.*?\b(?:Single|Double)\s+Layer\b)/i);

    if (layerMatch) return layerMatch[1].trim();

    return title.split('|').slice(0, 5).join('|').trim();
  };

  const shortenMobileProductTitle = (value) => {
    const parts = (value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .split('|')
      .map((part) => part.trim())
      .filter(Boolean);
    const millimeterIndex = parts.findIndex((part) => /(?:^Ø|\bmm\b)/i.test(part));
    let title = (millimeterIndex > 0 ? parts.slice(0, millimeterIndex) : parts).join(' | ');
    const layerMatch = title.match(/^(.*?\b(?:Single|Double)\s+Layer\b)/i);

    if (layerMatch) title = layerMatch[1].trim();
    if (title.length <= 56) return title;

    const clipped = title.slice(0, 57);
    const lastSpace = clipped.lastIndexOf(' ');

    return (lastSpace > 24 ? clipped.slice(0, lastSpace) : title.slice(0, 56)).trim() + '…';
  };

  const appendReviewText = (parent, className, value) => {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = value;
    parent.appendChild(span);
  };

  const updateReviewProductTitles = (widget) => {
    widget.querySelectorAll('.jdgm-rev').forEach((review) => {
      const row = review.querySelector('.jdgm-row-product');
      const title = (review.dataset.productTitle || '').trim();
      const url = (review.dataset.productUrl || '').trim();

      if (!row || !title) {
        return;
      }

      let titleLink = row.querySelector('.growber-product-reviews__purchased-product');
      if (!titleLink) {
        titleLink = document.createElement(url ? 'a' : 'span');
        titleLink.className = 'growber-product-reviews__purchased-product';
        if (url) {
          titleLink.href = url;
        }
        row.replaceChildren(titleLink);
      }

      if (url && titleLink.tagName === 'A' && titleLink.getAttribute('href') !== url) {
        titleLink.href = url;
      }

      const author = (review.querySelector('.jdgm-rev__author')?.textContent || '').trim();
      const country = normalizeReviewLocation(
        review.querySelector('.jdgm-rev__location')?.textContent || ''
      );
      const shortTitle = mobileReviewQuery.matches
        ? shortenMobileProductTitle(title)
        : shortenDesktopProductTitle(title);
      const lineKey = JSON.stringify([mobileReviewQuery.matches, title, author, country, url]);

      if (titleLink.dataset.growberProductLineKey !== lineKey) {
        titleLink.replaceChildren();
        appendReviewText(titleLink, 'growber-product-reviews__title-text', shortTitle);

        if (author || country) {
          const identity = document.createElement('span');
          identity.className = 'growber-product-reviews__title-identity';
          appendReviewText(identity, 'growber-product-reviews__title-separator', ' | ');
          if (author) {
            appendReviewText(identity, 'growber-product-reviews__title-author', author);
          }
          if (country) {
            appendReviewText(
              identity,
              'growber-product-reviews__title-country',
              (author ? ' ' : '') + country
            );
          }
          titleLink.appendChild(identity);
        }

        titleLink.dataset.growberProductLineKey = lineKey;
        titleLink.setAttribute(
          'aria-label',
          [title, [author, country].filter(Boolean).join(' ')].filter(Boolean).join(' | ')
        );
      }

      const ratingRow = review.querySelector('.jdgm-row-rating');
      const reviewTitle = review.querySelector(':scope > .jdgm-rev__content > .jdgm-rev__title');
      const reviewTitleText = (reviewTitle?.textContent || '').trim();
      let mobileTitle = ratingRow?.querySelector('.growber-product-reviews__mobile-title');

      if (ratingRow && reviewTitleText) {
        if (!mobileTitle) {
          mobileTitle = document.createElement('span');
          mobileTitle.className = 'growber-product-reviews__mobile-title';
          ratingRow.querySelector('.jdgm-rev__rating')?.insertAdjacentElement('afterend', mobileTitle);
        }
        if (mobileTitle.textContent !== reviewTitleText) {
          mobileTitle.textContent = reviewTitleText;
        }
      } else if (mobileTitle) {
        mobileTitle.remove();
      }
      review.classList.toggle('growber-product-review--mobile-title-inline', Boolean(reviewTitleText));

      const isVerified = Boolean(review.querySelector('.jdgm-rev__buyer-badge'));
      let verified = ratingRow?.querySelector('.growber-product-reviews__verified');

      if (ratingRow && isVerified) {
        if (!verified) {
          verified = document.createElement('span');
          verified.className = 'growber-product-reviews__verified';
          verified.textContent = 'Verifiziert';
          ratingRow.appendChild(verified);
        }
      } else if (verified) {
        verified.remove();
      }
    });
  };

  /* Growber product image filter */
  let imageMode = 'without';
  let previousSortValue = 'highest-rating';
  let internalSelectChange = false;

  const cameraIcon = `
    <span class="growber-product-image-toggle__icon" aria-hidden="true">
      <svg viewBox="0 0 32 32" focusable="false">
        <path d="M10.5 8.5 12.3 5h7.4l1.8 3.5H26a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-12a3 3 0 0 1 3-3h4.5Z"></path>
        <circle cx="16" cy="17" r="6"></circle>
      </svg>
    </span>
  `;

  const hasCustomerImage = (review) => Boolean(
    review.querySelector('.jdgm-rev__pics .jdgm-rev__pic-img, .jdgm-rev__pic-link')
  );

  const applyImageFilter = (widget) => {
    let visibleIndex = 0;

    widget.querySelectorAll('.jdgm-rev').forEach((review) => {
      const hasImage = hasCustomerImage(review);
      const hidden = imageMode === 'without' ? hasImage : !hasImage;

      review.classList.toggle('growber-product-review--filtered-image', hidden);
      if (!hidden) {
        review.setAttribute('data-growber-review-tone', visibleIndex % 2 === 0 ? 'grey' : 'white');
        visibleIndex += 1;
      }
    });

    widget.dataset.growberImageMode = imageMode;
  };

  const closeProductFilter = (control) => {
    if (!control) return;
    control.classList.remove('is-open');
    const trigger = control.querySelector('.growber-product-sort__trigger');
    const menu = control.querySelector('.growber-product-sort__menu');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
  };

  const changeNativeSelection = (select, value) => {
    if (!select || !value || select.value === value) return;

    internalSelectChange = true;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    internalSelectChange = false;
  };

  const syncProductFilter = (widget, control) => {
    if (!control) return;

    const onlyImages = imageMode === 'only';
    const value = control.querySelector('.growber-product-sort__value');
    const toggle = control.querySelector('.growber-product-image-toggle');

    const expectedValue = onlyImages ? 'NUR BILDER' : 'ALLE OHNE BILDER';
    if (value && value.textContent !== expectedValue) {
      value.textContent = expectedValue;
    }

    control.querySelectorAll('.growber-product-sort__option').forEach((option) => {
      const selected = onlyImages
        ? option.dataset.value === 'with-pictures'
        : option.dataset.value === 'growber-without-images';
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-selected', String(selected));
    });

    if (toggle) {
      toggle.setAttribute('aria-pressed', String(onlyImages));
      toggle.setAttribute(
        'aria-label',
        onlyImages
          ? 'Bilder ausblenden und Bewertungen ohne Bilder anzeigen'
          : 'Bilder anzeigen und nur Bewertungen mit Bildern anzeigen'
      );
      toggle.title = onlyImages ? 'Bilder ausblenden' : 'Nur Bewertungen mit Bildern anzeigen';
    }

    applyImageFilter(widget);
    updateVisibleReviewTones(widget);
  };

  const setImageMode = (widget, control, mode, updateNative = false) => {
    const select = widget.querySelector('.jdgm-sort-dropdown');

    if (mode === 'only' && select && select.value !== 'with-pictures') {
      previousSortValue = select.value || previousSortValue;
    }

    imageMode = mode;

    if (updateNative && select) {
      changeNativeSelection(
        select,
        mode === 'only' ? 'with-pictures' : previousSortValue
      );
    }

    window.setTimeout(() => syncProductFilter(widget, control), 80);
    window.setTimeout(() => {
      const currentControl = widget.querySelector('.growber-product-sort');
      syncProductFilter(widget, currentControl);
    }, 500);
  };

  const ensureProductFilter = (widget) => {
    const host = widget.querySelector('.jdgm-rev-widg__sort-wrapper');
    const select = host && host.querySelector('.jdgm-sort-dropdown');
    const nativeWrapper = select && select.closest('.jdgm-sort-dropdown-wrapper');
    if (!host || !select || !nativeWrapper) return;

    if (imageMode !== 'only' && select.value && select.value !== 'with-pictures') {
      previousSortValue = select.value;
    }

    let control = host.querySelector(':scope > .growber-product-sort');
    if (!control) {
      nativeWrapper.classList.add('growber-product-sort__native');

      control = document.createElement('div');
      control.className = 'growber-product-sort';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'growber-product-sort__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      const label = document.createElement('span');
      label.className = 'growber-product-sort__label';
      label.textContent = 'SORTIEREN NACH';

      const value = document.createElement('span');
      value.className = 'growber-product-sort__value';

      const arrow = document.createElement('span');
      arrow.className = 'growber-product-sort__arrow';
      arrow.setAttribute('aria-hidden', 'true');

      trigger.append(label, value, arrow);

      const menu = document.createElement('div');
      menu.className = 'growber-product-sort__menu';
      menu.id = 'growber-product-sort-' + Date.now();
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;
      trigger.setAttribute('aria-controls', menu.id);

      const addOption = (labelText, optionValue) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'growber-product-sort__option';
        option.dataset.value = optionValue;
        option.textContent = labelText;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.addEventListener('click', () => {
          if (optionValue === 'growber-without-images') {
            setImageMode(widget, control, 'without', true);
          } else if (optionValue === 'with-pictures') {
            setImageMode(widget, control, 'only', true);
          } else {
            previousSortValue = optionValue;
            imageMode = 'without';
            changeNativeSelection(select, optionValue);
            setImageMode(widget, control, 'without');
          }
          closeProductFilter(control);
          trigger.focus();
        });
        menu.appendChild(option);
      };

      addOption('ALLE OHNE BILDER', 'growber-without-images');
      Array.from(select.options).forEach((option) => {
        addOption(option.textContent.trim(), option.value);
      });

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const willOpen = menu.hidden;
        closeProductFilter(control);
        control.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', String(willOpen));
        menu.hidden = !willOpen;
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (menu.hidden) trigger.click();
          const selected = menu.querySelector('.is-selected') || menu.querySelector('.growber-product-sort__option');
          if (selected) selected.focus();
        }
        if (event.key === 'Escape') {
          closeProductFilter(control);
        }
      });

      menu.addEventListener('keydown', (event) => {
        const options = Array.from(menu.querySelectorAll('.growber-product-sort__option'));
        const current = options.indexOf(document.activeElement);
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          options[(current + direction + options.length) % options.length].focus();
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          closeProductFilter(control);
          trigger.focus();
        }
      });

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'growber-product-image-toggle';
      toggle.innerHTML = cameraIcon;
      toggle.addEventListener('click', () => {
        setImageMode(widget, control, imageMode === 'only' ? 'without' : 'only', true);
        toggle.focus();
      });

      control.append(trigger, menu, toggle);
      host.appendChild(control);
    }

    if (select.dataset.growberProductFilterReady !== 'true') {
      select.dataset.growberProductFilterReady = 'true';
      select.addEventListener('change', () => {
        if (internalSelectChange) return;
        if (select.value === 'with-pictures') {
          imageMode = 'only';
        } else {
          previousSortValue = select.value || previousSortValue;
          imageMode = 'without';
        }
        window.setTimeout(() => syncProductFilter(widget, widget.querySelector('.growber-product-sort')), 80);
      });
    }

    syncProductFilter(widget, control);
  };

  const enhanceWidget = (widget) => {
    widget.classList.add('growber-product-reviews');
    ensureProductFilter(widget);
    updateReviewProductTitles(widget);

    const actions = widget.querySelector('.jdgm-widget-actions-wrapper');
    const productButton = actions && actions.querySelector('.jdgm-write-rev-link');

    if (productButton) {
      if (productButton.textContent.trim() !== 'Produkt bewerten') {
        productButton.textContent = 'Produkt bewerten';
      }
      productButton.setAttribute('aria-label', 'Produkt bewerten');
      productButton.classList.add('growber-product-reviews__product-button');

      let shopButton = actions.querySelector('.growber-product-reviews__shop-button');
      if (!shopButton) {
        shopButton = document.createElement('a');
        shopButton.className = 'growber-product-reviews__shop-button';
        shopButton.href = '/pages/reviews';
        shopButton.textContent = 'Shop bewerten';
        shopButton.setAttribute('aria-label', 'Growber als Shop bewerten');
        actions.appendChild(shopButton);
      }
    }

    if (widget.dataset.growberProductReviewsReady !== 'true') {
      widget.dataset.growberProductReviewsReady = 'true';
      widget.addEventListener('click', () => scheduleToneUpdate(widget), true);
      widget.addEventListener('change', () => scheduleToneUpdate(widget), true);

      const widgetObserver = new MutationObserver(() => scheduleToneUpdate(widget));
      widgetObserver.observe(widget, { childList: true, subtree: true });
    }

    updateVisibleReviewTones(widget);
  };

  const initialize = () => {
    document.querySelectorAll(widgetSelector).forEach(enhanceWidget);
  };

  const start = () => {
    initialize();
    if (document.documentElement.dataset.growberProductFilterCloseReady !== 'true') {
      document.documentElement.dataset.growberProductFilterCloseReady = 'true';
      document.addEventListener('click', (event) => {
        document.querySelectorAll('.growber-product-sort.is-open').forEach((control) => {
          if (!event.target.closest('.growber-product-sort')) {
            closeProductFilter(control);
          }
        });
      });
    }
    if (!pageObserver && document.body) {
      pageObserver = new MutationObserver(initialize);
      pageObserver.observe(document.body, { childList: true, subtree: true });
    }
    if (document.documentElement.dataset.growberProductReviewViewportReady !== 'true') {
      document.documentElement.dataset.growberProductReviewViewportReady = 'true';
      mobileReviewQuery.addEventListener('change', initialize);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
